import { env } from '@/src/config/env'

import { APP_TYPE } from '../../enums/appTypes'
import { isIOSWeb } from '../../utils/isIOSWeb'
import { Cookie } from '../cookies/Cookie'
import { getAppType } from '../getAppType'
import { vwoUnsafeHtml } from './js_script'

const CAMPAIGN_ID = '60'

declare global {
  interface Window {
    VWO: Array<any>
  }
}

/**
 * Loads VWO for the given variant
 * 1: control
 * 2: variantA
 * The control variant is forced on iOS and desktop, where the storytelling banner cannot be displayed correctly
 * @param variant 1|2
 */
export const loadVwoForVariant = (variant: 1 | 2) => {
  window.VWO = window.VWO || []

  const isIOS = isIOSWeb()

  const isDesktop = getAppType() === APP_TYPE.BROWSER_DESKTOP

  // iOS disabled because banner doesn't work correctly
  // Desktop disabled because it doesn't performs well
  const shouldForceVariant1 = isIOS || isDesktop

  if (shouldForceVariant1) {
    Cookie.set('_vis_opt_exp_60_combi', 1, { Path: '/' })
  }

  console.debug('🤡 Initializing VWO')
  if (window.VWO[0] == null) {
    if (variant !== 1 && variant !== 2) {
      console.error('🤡 VWO variant not set, variant must be 1 or 2')
      return
    } else {
      console.debug('🤡 VWO variant not set, setting variation')
      console.debug(`🤡 Set variant to ${shouldForceVariant1 ? '1' : `${variant}`}`)
      window.VWO.push([
        'setVariation',
        [
          {
            e: CAMPAIGN_ID,
            // We force the variant to be 1 for all iOS and desktop users
            v: shouldForceVariant1 ? '1' : `${variant}`,
          },
        ],
      ])
    }
  }

  console.debug(`🤡 VWO variant loaded : ${window.VWO[0]}`)
  if (!document.getElementById('vwoCode')) {
    const vwoScript = document.createElement('script')
    vwoScript.textContent = vwoUnsafeHtml[env.EXPO_PUBLIC_APP_VARIANT]
    vwoScript.id = 'vwoCode'
    document.head.appendChild(vwoScript)
  } else {
    console.debug('🤡 VWO script already loaded')
  }
}
